"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var md_1 = require("react-icons/md");
var io_1 = require("react-icons/io");
var icons_1 = require("../../../icons");
var constant_1 = require("../../../constant");
var styles_1 = require("./styles");
var Icon = function (_a) {
    var checked = _a.checked, indeterminate = _a.indeterminate, error = _a.error, disabled = _a.disabled, _b = _a.type, type = _b === void 0 ? 'default' : _b;
    var theme = react_1.useTheme();
    var styles = react_2.useMemo(function () { return styles_1.getCheckboxIconStyles(theme, type); }, [theme, type]);
    var iconStyle = react_2.useMemo(function () { return [
        styles.container,
        checked ? styles.checkedContainer : undefined,
        indeterminate ? styles.indeterminateContainer : undefined,
        error ? styles.errorContainer : undefined,
        disabled ? styles_1.getDisabledStyle(checked, indeterminate, theme.name) : undefined,
    ]; }, [checked, disabled, error, indeterminate, styles, theme.name]);
    var iconProps = react_2.useMemo(function () { return styles_1.getCheckboxIconProps(theme); }, [theme]);
    var isTheme6DS = theme.name === constant_1.DESIGN_SYSTEM;
    var IconComponent = null;
    var className = 'icon';
    if (indeterminate) {
        IconComponent = isTheme6DS ? icons_1.Minus : io_1.IoMdSquare;
        className = 'icon-indeterminate';
    }
    else if (checked) {
        IconComponent = isTheme6DS ? icons_1.Check : md_1.MdCheck;
        className = 'icon-checked';
    }
    return (react_1.jsx("span", { css: iconStyle, className: className }, IconComponent && react_1.jsx(IconComponent, __assign({}, iconProps, { strokeWidth: "1.5" }))));
};
exports.Icon = Icon;
exports.default = exports.Icon;
